"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../constants");

var _Button = _interopRequireDefault(require("../Buttons/Button"));

var _CardButton = _interopRequireDefault(require("../Buttons/CardButton"));

var _Card = _interopRequireDefault(require("../Card"));

var _CardActions = _interopRequireDefault(require("../CardActions"));

var _Select = _interopRequireDefault(require("../Select"));

var _TooltipForTruncatedText = _interopRequireDefault(require("../TooltipForTruncatedText"));

var _CircleStepIcon = _interopRequireDefault(require("./CircleStepIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const WizardContainer = _styledComponents.default.div`
	width: ${props => props.width}px;
	max-width: 100%;
`;
const StepContentsWrapper = _styledComponents.default.div`
	padding-top: 10px;
`;
const TitleBarWrapper = _styledComponents.default.div`
	padding: 19px 30px 19px 30px;
	background-color: ${_constants.colours.wizardCardBackground};
`;
const Separator = _styledComponents.default.div`
	height: 1px;
	background-color: ${_constants.colours.wizardTitleSeparator};
`;
const BodyWrapper = _styledComponents.default.div`
	padding: 30px 30px;
	line-height: ${_constants.fontSizes.body};
	background-color: ${_constants.colours.wizardCardBackground};
	overflow: auto;
	font-size: ${_constants.fontSizes.body};
	position: relative;
`;
const TitleToolbarSaveButton = (0, _styledComponents.default)(_core.Grid)`
	&.MuiGrid-root {
		padding-top: 4px;
		text-align: right;
	}
`;
const Steptitle = (0, _styledComponents.default)(_core.Typography)`
	&.MuiTypography-root {
		font-size: ${_constants.fontSizes.subtitle4};
		line-height: 1.25rem;
		font-weight: normal;
		opacity: 0.6;
	}
`;
const CustomStepper = (0, _styledComponents.default)(_core.Stepper)`
	&.MuiStepper-root {
		justify-content: center;
		padding: 6px;
		background-color: transparent;
	}
`;
const BackButton = (0, _styledComponents.default)(_Button.default)`
	&.MuiButton-root {
		position: absolute;
		background-color: ${_constants.colours.mediumGrey};
	}
	&.MuiButton-root .MuiButton-label {
		font-size: ${_constants.fontSizes.subtitle4};
		line-height: ${_constants.fontSizes.subtitle4};
	}
`;
const CustomStepButton = (0, _styledComponents.default)(_core.StepButton)`
	&.MuiStepButton-root {
		padding: 0 2px;
		margin: 0;
	}
	&.MuiStepButton-root .MuiStepLabel-iconContainer {
		padding: 0;
	}
`;
const CustomStep = (0, _styledComponents.default)(_core.Step)`
	&.MuiStep-root {
		padding: 0 1px;
	}
`;
const CustomMenuItem = (0, _styledComponents.default)(_core.MenuItem)`
	&.MuiMenuItem-root {
		display: block;
	}
`;
const TitleSelect = (0, _styledComponents.default)(_Select.default)`
	max-width: calc(100%);
	min-width: 100px;
	& .MuiSelect-icon {
		border: 0;
	}
	& fieldset {
		border: 0;
	}
	& .MuiSelect-root {
		padding: 0;
	}
	& .MuiSelect-outlined {
		padding-right: 35px !important;
	}
	& svg {
		margin-top: 20px;
		height: 23px;
		fill: ${_constants.colours.font};
	}
`;
const WizardCard = (0, _styledComponents.default)(_Card.default)`
	&.MuiCard-root {
		max-width: fit-content;
	}
`;
const Title = (0, _styledComponents.default)(_core.Typography)`
	&.MuiTypography-root {
		font-size: ${_constants.fontSizes.subtitle1};
		line-height: 23px;
		font-weight: bold;
	}
`;
const ForceChildSizeToContainerGrid = (0, _styledComponents.default)(_core.Grid)`
	&.MuiGrid-root {
		position: relative;
		min-height: 42px;
	}
	&.MuiGrid-root > :first-child {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
`;
const MyLineConnector = (0, _styledComponents.default)(_core.StepConnector)`
	&.MuiStepConnector-root {
		flex: 0 0 auto;
	}
`;
const useStyles = (0, _core.makeStyles)(() => ({
  titleSelectMenu: {
    '& ul': {
      padding: 0,
      '& .MuiListItem-root.Mui-selected': {
        backgroundColor: _constants.colours.blue,
        color: _constants.colours.white
      }
    }
  }
}));
const Wizard = /*#__PURE__*/(0, _react.forwardRef)(({
  actionLabel,
  cancelLabel,
  children,
  steps,
  style,
  width,
  titleNoWrap,
  editMode,
  editModeTitleBarSaveBtnLabel,
  editModeTitleBarSaveBtnHandler,
  ...otherProps
}, ref) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = (0, _react.useState)(0);

  const changeActiveStep = step => {
    let newStep = step;

    if (step >= steps.length) {
      newStep = steps.length - 1;
    }

    if (step < 0) {
      newStep = 0;
    }

    const goToStep = () => {
      setActiveStep(newStep);
    };

    if (steps[activeStep] && (steps[activeStep].onBeforeStepChange || steps[newStep] && steps[newStep].onBeforeStepActive)) {
      if (steps[activeStep].onBeforeStepChange) {
        steps[activeStep].onBeforeStepChange().then(response => {
          if (response && steps[newStep] && steps[newStep].onBeforeStepActive) {
            return steps[newStep].onBeforeStepActive();
          }

          return Promise.resolve(response);
        }).then(response => {
          if (response) {
            goToStep();
          }
        });
      } else {
        steps[newStep].onBeforeStepActive().then(response => {
          if (response) {
            goToStep();
          }
        });
      }
    } else {
      goToStep();
    }
  };

  const handleStep = step => {
    changeActiveStep(step);
  };

  const handleBack = () => {
    changeActiveStep(activeStep - 1);
  };

  _react.default.useImperativeHandle(ref, () => ({
    // method used from parent to change the active step
    // if the step parameter is set, the active step will be given by this parameter
    // if you want to go to the next step, set the step param to null and set the increse to 1
    // if you want to go to the previous step, set the step param to null and the increase to -1
    changeActiveStep(step, increase) {
      if (step === null) {
        if (increase !== null && activeStep < steps.length - 1) {
          changeActiveStep(activeStep + increase);
        }
      } else {
        changeActiveStep(step < 0 ? 0 : step);
      }
    },

    getCurrentStep() {
      return activeStep;
    }

  }), [changeActiveStep, activeStep, steps]);

  const hasSteps = () => {
    return steps && steps.length > 0;
  };

  const getTitleNode = (stepNumber, title, optional, noWrap) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Steptitle, {
    noWrap: noWrap
  }, `STEP ${stepNumber + 1} `, optional ? '(Optional)' : ''), /*#__PURE__*/_react.default.createElement(_TooltipForTruncatedText.default, {
    title: title
  }, /*#__PURE__*/_react.default.createElement(Title, {
    align: "left",
    noWrap: noWrap
  }, title)));

  const getEditModeTitleBar = () => /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(ForceChildSizeToContainerGrid, {
    item: true,
    xs: true
  }, /*#__PURE__*/_react.default.createElement(TitleSelect, {
    value: activeStep,
    displayEmpty: true,
    MenuProps: {
      className: classes.titleSelectMenu,
      PaperProps: {
        style: {
          maxHeight: 365,
          maxWidth: 450
        }
      },
      getContentAnchorEl: null,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      }
    },
    renderValue: () => getTitleNode(activeStep, steps[activeStep].label, steps[activeStep].optional, true),
    onChange: e => handleStep(e.target.value)
  }, steps.map((step, index) => /*#__PURE__*/_react.default.createElement(CustomMenuItem, {
    value: index,
    key: `active-${step.key}`
  }, getTitleNode(index, step.label, step.optional, false))))), editModeTitleBarSaveBtnHandler && activeStep < steps.length - 1 && /*#__PURE__*/_react.default.createElement(TitleToolbarSaveButton, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    onClick: editModeTitleBarSaveBtnHandler
  }, editModeTitleBarSaveBtnLabel)));

  const getWizardStepper = () => /*#__PURE__*/_react.default.createElement(CustomStepper, _extends({
    connector: /*#__PURE__*/_react.default.createElement(MyLineConnector, null),
    activeStep: activeStep
  }, otherProps), steps && steps.map((stepInfo, index) => /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: stepInfo.label || '',
    key: stepInfo.key || stepInfo.label
  }, /*#__PURE__*/_react.default.createElement(CustomStep, {
    disabled: !stepInfo.enableButton
  }, /*#__PURE__*/_react.default.createElement(CustomStepButton, {
    onClick: () => handleStep(index),
    disabled: !stepInfo.enableButton
  }, /*#__PURE__*/_react.default.createElement(_core.StepLabel, {
    StepIconComponent: _CircleStepIcon.default,
    active: index === activeStep,
    completed: false
  }))))));

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(WizardCard, null, /*#__PURE__*/_react.default.createElement(WizardContainer, {
    width: hasSteps() && steps[activeStep].width || width
  }, /*#__PURE__*/_react.default.createElement(TitleBarWrapper, null, !editMode && hasSteps() && steps[activeStep] && getTitleNode(activeStep, steps[activeStep].label, steps[activeStep].optional, titleNoWrap), hasSteps() && editMode && steps[activeStep] && getEditModeTitleBar()), /*#__PURE__*/_react.default.createElement(Separator, null), /*#__PURE__*/_react.default.createElement(BodyWrapper, null, activeStep > 0 && /*#__PURE__*/_react.default.createElement(BackButton, {
    variant: "contained",
    disabled: activeStep === 0,
    onClick: handleBack
  }, /*#__PURE__*/_react.default.createElement(_ArrowBack.default, {
    fontSize: "small"
  }), "back"), getWizardStepper(), /*#__PURE__*/_react.default.createElement(StepContentsWrapper, null, hasSteps() && steps[activeStep].stepContent || /*#__PURE__*/_react.default.createElement("div", null, "No Content")))), /*#__PURE__*/_react.default.createElement(_CardActions.default, {
    disableSpacing: true
  }, /*#__PURE__*/_react.default.createElement(_CardButton.default, {
    onClick: hasSteps() && steps[activeStep].onCancel || null
  }, hasSteps() && steps[activeStep].cancelLabel || cancelLabel), /*#__PURE__*/_react.default.createElement(_CardButton.default, {
    primary: true,
    onClick: hasSteps() && steps[activeStep].onNext || null
  }, hasSteps() && steps[activeStep].actionLabel || actionLabel))));
});
Wizard.propTypes = {
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.number,
    label: _propTypes.default.node,
    optional: _propTypes.default.bool,
    enableButton: _propTypes.default.bool,
    stepContent: _propTypes.default.node,
    onNext: _propTypes.default.func.isRequired,
    onCancel: _propTypes.default.func.isRequired,
    width: _propTypes.default.number,
    onBeforeStepChange: _propTypes.default.func,
    onBeforeStepActive: _propTypes.default.func
  })),
  cancelLabel: _propTypes.default.string,
  actionLabel: _propTypes.default.string,
  width: _propTypes.default.number,
  titleNoWrap: _propTypes.default.bool,
  editMode: _propTypes.default.bool,
  editModeTitleBarSaveBtnLabel: _propTypes.default.string,
  editModeTitleBarSaveBtnHandler: _propTypes.default.func
};
Wizard.defaultProps = {
  steps: [],
  cancelLabel: 'Cancel',
  actionLabel: 'Next',
  width: 100000,
  titleNoWrap: false,
  editMode: false,
  editModeTitleBarSaveBtnLabel: 'Save',
  editModeTitleBarSaveBtnHandler: null
};
var _default = Wizard;
exports.default = _default;